"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
class BadBatchRequestError extends client_library_1.ExtendableError {
    constructor() {
        super(`Bad batch request`);
    }
}
exports.default = BadBatchRequestError;
//# sourceMappingURL=BadBatchRequestError.js.map